module.exports = __webpack_public_path__ + "img/loading.886c3cf4.png";